export default function filterAvailableApplicators(
  people: { id: string; name: string }[],
  applicators: { personId?: string }[],
  currentApplicatorId?: string
): { id: string; name: string }[] {
  if (!Array.isArray(people) || !people.length) {
    return [];
  }

  return people.filter(
    person =>
      !applicators.some(
        (applicator: { personId?: string }) =>
          applicator.personId === person.id &&
          applicator.personId !== currentApplicatorId
      )
  );
}
